var make = require('./make_');
var arrMin = require('../array/min');
var objMin = require('../object/min');

    /**
     * Get minimum value inside collection.
     */
    module.exports = make(arrMin, objMin);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/min.js
// module id = 1576
// module chunks = 0 1 2